import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_outbound_dlp'

function OutboundDlpI18n({ classes, productName }: { classes: ReturnType<typeof styles>; productName?: string }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <div className={classes.content} data-testid="content">
      <p>{formatMessage('note', { productName })}</p>
      <br />
      <br />
      {formatMessage('description')}
      <br />
      <br />
      {formatMessage('sorting')}
      <ul>
        <li>{formatMessage('columns.domain_name')}</li>
        <li>{formatMessage('columns.comment')}</li>
      </ul>
    </div>
  )
}

function OutboundDlp(props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <OutboundDlpI18n classes={classes} productName={props.productName} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      <p>
        <b>Note</b>: These settings apply to all domains you have verified in {props.productName} for processing email,
        unless you change these settings for a specific domain. In that case, the domain-level settings override the
        global system settings.
      </p>
      <br />
      <br />
      Domain names added to this page have <b>Force TLS</b> enabled for outbound mail. Mail sent to these domains must
      be transmitted across a TLS connection. If a TLS connection cannot be established, then mail is not delivered.
      <br />
      <br />
      Click on one of the following table headings to sort the table:
      <ul>
        <li>Domain Name</li>
        <li>Comment</li>
      </ul>
    </div>
  )
}

export default OutboundDlp
